import ShopifyServices from "./shopify-services.js"
import { dissectForm } from "../utils/dissect-form.js"
import { dissectFormMultiple } from "../utils/dissect-form-multiple"
import { getCartSectionsToRender } from "../utils/get-sections.js"

class ShopifyCart extends ShopifyServices {
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData {object}
   * @param selectedElement {HTMLElement}
   *
   * @returns cart object
   */
  async add(formData, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/add.js"
    const body = JSON.stringify({
      ...JSON.parse(dissectForm(formData)),
    })

    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }

  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData {object}
   * @param selectedElement {HTMLElement}
   *
   * @returns cart object
   */
  async addMultiple(formData, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/add.js"
    const body = JSON.stringify({
      ...JSON.parse(dissectFormMultiple(formData)),
    })

    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }

  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async removeByLine(line, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/change.js"
    const body = JSON.stringify({
      line: line,
      quantity: 0,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }

  /**
   * Remove item from the cart.
   *
   * @param id {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async removeById(id, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/change.js"
    const body = JSON.stringify({
      id: id,
      quantity: 0,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }

  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async updateQuantity(line, quantity, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/change.js"
    const body = JSON.stringify({
      line: line,
      quantity: quantity,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    })

    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }

  /**
   * Quick buy option.
   *
   * @param variantId {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async quickBuy(variantId, quantity, selectedElement) {
    const method = "POST"
    const url = window.Shopify.routes.root + "cart/add.js"
    const body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: getCartSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    })
    // Update the cart with the updateCart function of the Shopify Services class.
    await this.updateCart(method, url, selectedElement, body)
  }
}

export default new ShopifyCart()
